import { render } from "./TopUsersCard.vue?vue&type=template&id=5a36cce4"
import script from "./TopUsersCard.vue?vue&type=script&lang=js"
export * from "./TopUsersCard.vue?vue&type=script&lang=js"
script.render = render

export default script